import React, { useEffect } from "react";

import Loading from "../../../../utils/Loading";

export const GoogleCallbackRoute = () => {
  useEffect(() => {
    if (window.opener) {
      // send them to the opening window
      window.opener.postMessage({ type: "google-login" });
      // close the popup
      window.close();
    }
  }, []);

  return <Loading />;
};
